<div *ngIf="reportType == 'GSTFullReport'">

  <div class="container-fluid" id="print-section">
    <table class="gst-table">
      <thead>
        <tr class="header-title">
          <th colspan="4">Hindustan - Vivek Saptahik</th>
          <th colspan="9">Issue Seller GST Register</th>
          <th colspan="3">Date : From {{startDate}} To {{endDate}}</th>
          <th colspan="2">Date :</th>
          <th colspan="1">Page No :</th>
        </tr>

        <tr class="header-columns">
          <th>Invoice Date</th>
          <th>Invoice No</th>
          <th colspan="2">Issue Seller Name</th>
          <th colspan="2">English Issue<br> Seller Name</th>
          <th>District</th>
          <th>GST No</th>
          <th>HSN No</th>
          <th>Issue Copies</th>
          <th>Issue Net Amt</th>
          <th>CGST Rate</th>
          <th>CGST Amt</th>
          <th>SGST Rate</th>
          <th>SGST Amt</th>
          <th>IGST Rate</th>
          <th>IGST Amount</th>
          <th>Roundup Amt</th>
          <th>GST Amt</th>
        </tr>
      </thead>

      <tbody *ngFor="let data of GSTfullreportFormBeans">
        <tr>
          <td>{{data.invoice_date}}</td>
          <td>{{data.invoice_no}}</td>
          <td colspan="2">{{data.issue_Seller_Name}}</td>
          <td colspan="2">{{data.eng_Issue_seller_name}}</td>
          <td>{{data.eng_district}}</td>
          <td>{{data.gst_no}}</td>
          <td>998363</td>
          <td>{{data.issue_size}}</td>
          <td class="text-end">{{data.before_gst_amt}}</td>
          <td class="text-end">{{data.cgst_rate}}%</td>
          <td class="text-end">{{data.cgst}}</td>
          <td class="text-end">{{data.sgst_rate}}%</td>
          <td class="text-end">{{data.sgst}}</td>
          <td class="text-end">{{data.igst_rate}}%</td>
          <td class="text-end">{{data.igst}}</td>
          <td class="text-end">{{data.round_up_amt}}</td>
          <td class="text-end">{{data.gst_amount}}</td>
        </tr>
      </tbody>

      <tfoot>
        <tr class="total-row">
          <td colspan="10"><strong>Total-</strong></td>
          <td class="text-end">{{beforegstamt}}</td>
          <td></td>
          <td class="text-end">{{CGSTAmount}}</td>
          <td></td>
          <td class="text-end">{{SGSTAmount}}</td>
          <td></td>
          <td class="text-end">{{IGSTAmount}}</td>
          <td class="text-end">0</td>
          <td class="text-end">{{AllGSTAmount}}</td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div class="button-container noPrint"style="text-align: right; margin: 20px 0;">
    <button (click)="exportExcel('GST_Report')" mat-raised-button color="primary"[useExistingCss]="true"printSectionId="print-section">
      Export
    </button>
  
    <button mat-raised-button color="primary"[useExistingCss]="true"printSectionId="print-section" ngxPrint>
      Print
    </button>
  
    <button mat-button mat-dialog-close>
      Close
    </button>
  </div>
  
</div>
